import { useRouteMatch } from 'react-router';
import { useRouteParams } from 'utils/hooks/useRouteParams';
import { DataSyncIndexPage } from './index/DataSyncIndexPage';
import { DestinationFormPage } from './destination/DestinationFormPage';
import { TransferHistoryPage } from './transfer/TransferHistoryPage';

type DataSyncRouteParams = {
  destinationId?: string;
  destinationType?: string;
};

export const DataSyncPage = () => {
  const { destinationId, destinationType } = useRouteParams<DataSyncRouteParams>();

  const createMatch = useRouteMatch('/integrations/dataSync/create/:destinationType');
  const editMatch = useRouteMatch('/integrations/dataSync/edit/:destinationId');
  const transferHistoryMatch = useRouteMatch(
    '/integrations/dataSync/transferHistory/:destinationId',
  );

  const renderContent = () => {
    // Determine what to render based on route matches
    if (createMatch && destinationType) {
      return <DestinationFormPage mode="create" destinationId={destinationType} />;
    }

    if (editMatch && destinationId) {
      return <DestinationFormPage mode="edit" destinationId={destinationId} />;
    }

    if (transferHistoryMatch && destinationId) {
      return <TransferHistoryPage destinationId={destinationId} />;
    }

    // Default to index page
    return <DataSyncIndexPage />;
  };

  return renderContent();
};
